import styled from 'styled-components'

import { Badge } from '@/components/ui/badge'

export const DateTimeCell = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space[2],
}))

export const CapitalizedBadge = styled(Badge)(() => ({
  textTransform: 'capitalize',
}))
